import { render } from "./RegistrationPassword.vue?vue&type=template&id=1ec3a4c0&scoped=true&ts=true"
import script from "./RegistrationPassword.vue?vue&type=script&lang=ts"
export * from "./RegistrationPassword.vue?vue&type=script&lang=ts"

import "./RegistrationPassword.vue?vue&type=style&index=0&id=1ec3a4c0&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec3a4c0"]])

export default __exports__